import React, { useState } from "react";
import "./HorizontalBarChart.css";

// Sequential, single-hue magnitude ranking (dataviz: choosing-a-form.md ->
// "compare magnitude, low->high" -> bar chart, sequential color job). Flat
// fill (palette slot-1 blue, #2a78d6) since this is one series of ranked
// bars, not a two-dimensional magnitude scale.
const BAR_COLOR = "var(--an-accent)";
const GRIDLINE_COLOR = "var(--an-border-soft)";

const HorizontalBarChart = ({ items, valueFormatter = (v) => v, maxItems = 15, threshold }) => {
  const [hoveredKey, setHoveredKey] = useState(null);

  if (!items || items.length === 0) {
    return <div className="hbar-empty">No data for the current filters.</div>;
  }

  const visible = items.slice(0, maxItems);
  const overflow = items.length - visible.length;
  const maxValue = Math.max(...visible.map((i) => i.value), threshold?.value || 0, 1);
  const thresholdPct = threshold ? Math.min(threshold.value / maxValue, 1) : null;

  return (
    <div className="hbar-chart">
      <div className="hbar-gridlines" aria-hidden="true">
        {[0, 0.25, 0.5, 0.75, 1].map((step) => (
          <div key={step} className="hbar-gridline" style={{ left: `${step * 100}%`, background: GRIDLINE_COLOR }} />
        ))}
      </div>

      {threshold && (
        <div
          className="hbar-threshold-line"
          style={{ left: `calc(200px + (100% - 270px) * ${thresholdPct})` }}
        >
          <span className="hbar-threshold-label">{threshold.label}</span>
        </div>
      )}

      {visible.map((item) => {
        const pct = Math.max((item.value / maxValue) * 100, 1);
        const isHovered = hoveredKey === item.key;
        return (
          <div
            key={item.key}
            className={`hbar-row${isHovered ? " hbar-row-hovered" : ""}`}
            onMouseEnter={() => setHoveredKey(item.key)}
            onMouseLeave={() => setHoveredKey(null)}
            title={`${item.label}: ${valueFormatter(item.value)}`}
          >
            <span className="hbar-label" title={item.label}>{item.label}</span>
            <div className="hbar-track">
              <div
                className="hbar-fill"
                style={{ width: `${pct}%`, background: BAR_COLOR }}
              />
            </div>
            <span className="hbar-value">{valueFormatter(item.value)}</span>

            {isHovered && (
              <div className="hbar-tooltip">
                <strong>{item.label}</strong>
                <span>{valueFormatter(item.value)}</span>
              </div>
            )}
          </div>
        );
      })}

      {overflow > 0 && (
        <div className="hbar-overflow-note">+{overflow} more in the table below</div>
      )}
    </div>
  );
};

export default HorizontalBarChart;
